package kz.dentalcrm.app.screens.protocols.list.mvi

import kotlinx.collections.immutable.PersistentList
import kotlinx.collections.immutable.persistentListOf
import kz.dentalcrm.app.core.base.ViewState
import kz.dentalcrm.app.data.network.response_model.protocol_templates.ProtocolTemplate

data class ProtocolsViewState(
    val search: String = "",
    val treatments: PersistentList<ProtocolTemplate> = persistentListOf(),
    val screenState: ScreenState = ScreenState.Idle
) : ViewState {
    sealed interface ScreenState {
        data object Loading : ScreenState
        data class Error(val text: String) : ScreenState
        data object Idle : ScreenState
    }
}
